import "./facilityDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import FacilityDetailsViewComponent from "./facility-details-view/facilityDetailsViewComponent";
import FacilityDetailsEditComponent from "./facility-details-edit/facilityDetailsEditComponent";

interface FacilityDetailsViewEditComponentProps {
    facilityDetails: any;
    onUpdateFacilityInformation: Function;
    onModeChange: Function;
    canEdit: boolean;
}

const FacilityDetailsViewEditComponent = (props: FacilityDetailsViewEditComponentProps) => {
    const {facilityDetails, onUpdateFacilityInformation,onModeChange,canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [facilityInformation, setFacilityFacilityInformation] = useState<any>(undefined);

    const handleFacilityInformationUpdate = useCallback((updatedFacilityInformation: any) => {
        onUpdateFacilityInformation(updatedFacilityInformation);
        setMode("view");
    }, [onUpdateFacilityInformation]);

    const handleFacilityInformationEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (facilityDetails) {
            setFacilityFacilityInformation(facilityDetails);
        }
    }, [facilityDetails]);

    useEffect(()=>{
        onModeChange(mode);
    },[mode,onModeChange]);

    return (
        <div className={'facility-details-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && <FacilityDetailsViewComponent
                    facilityInformation={facilityInformation}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" && <FacilityDetailsEditComponent facilityInformation={facilityInformation}
                                                              onUpdateComplete={handleFacilityInformationUpdate}
                                                              onEditCancel={handleFacilityInformationEditCancel}
                />
            }
        </div>
    );

};

export default FacilityDetailsViewEditComponent;